module.exports = __webpack_public_path__ + "img/img2.009dcb71.svg";